import { datum } from "./fxAnzeige.ts";
import { FxDialog } from "./FxDialog.tsx";
import { SicherungDetail, type SicherungDetailProps } from "./SicherungDetail.tsx";
import { sicherungsNr } from "../../lib/sicherungsNummer.ts";

export interface SicherungDetailDialogProps extends SicherungDetailProps {
  onSchliessen: () => void;
}

/**
 * Detail-Panel "Sicherung S-n": oeffnet sich per Klick auf eine Zeile der Sicherungstabelle und bietet, was die
 * Tabelle nicht kann (Beleg, Bindung an Bestellungen, Datum/Bank/Kurs/Betrag bearbeiten). Die Eingaben schreiben wie
 * bisher sofort ueber die Rueckrufe der Seite; der Dialog haelt nur den Rahmen.
 */
export function SicherungDetailDialog({ onSchliessen, onOeffnen, ...detail }: SicherungDetailDialogProps) {
  const { deal } = detail;
  return (
    <FxDialog
      titelId="sicherungDetailTitel"
      titel={`Sicherung ${sicherungsNr(deal)}`}
      untertitel={<>{deal.date ? datum(deal.date) : "ohne Stichtag"}{deal.snapshotId ? " · übernommen" : " · offen"}</>}
      beschaeftigt={false}
      onSchliessen={onSchliessen}
      onAbsenden={(ereignis) => ereignis.preventDefault()}
      breit
      fuss={<button className="btn-sec" type="button" onClick={onSchliessen}>Schließen</button>}
    >
      {/* Ein Tieflink zur Bestellung oeffnet deren Drawer; das Panel schliesst sich dabei, damit es ihn nicht verdeckt. */}
      <SicherungDetail {...detail} onOeffnen={(bestellungId) => { onSchliessen(); onOeffnen(bestellungId); }} />
    </FxDialog>
  );
}
